import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppDispatch, AppThunk} from "../store";
import {AuthMeModel} from "../../models/auth-me.model";

export interface AuthInitialState {
    logged: boolean;
    user: AuthMeModel;
}

const initialState: AuthInitialState = {
    logged: false,
    user: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logged(state, action: PayloadAction<AuthMeModel>) {
            state.logged = true;
            state.user = action.payload;
        },
        logout(state) {
            state.logged = false;
            state.user = null;
        },
        updateNickName(state, action: PayloadAction<string>) {
            state.user.author.nickname = action.payload;
        }
    }
});

export const logged = (authModal: AuthMeModel): AppThunk => async (dispatch: AppDispatch) => {
    dispatch(authSlice.actions.logged(authModal));
}

export const logout = (): AppThunk => async (dispatch: AppDispatch) => {
    dispatch(authSlice.actions.logout());
}

export const updateNickName = (nickName: string): AppThunk => async (dispatch: AppDispatch) => {
    dispatch(authSlice.actions.updateNickName(nickName));
}

export default authSlice.reducer;
